import { AppContext } from '@nile/components';
import { useContext } from 'react';

function MSPCurrencyCell(props) {
  const { company } = useContext(AppContext);
  const { cell, column } = props;

  const { meta } = column || {};
  const currencyCode =
    meta?.currentSubscription?.currentPlanPrice?.currency?.currencyCode ||
    'USD';
  const countryCode = company?.countryCode || 'US';

  return new Intl.NumberFormat(`en-${countryCode}`, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 2,
    currencyDisplay: 'narrowSymbol'
  }).format(cell?.value / 100 || 0);
}

export default MSPCurrencyCell;
